<template>
    <div>
        <!-- CAMPAIGNS -->

        <template v-if="campaign.blnBankrateSelect">
            <div class="col-xs-2">
                <a :href="campaignUrl(campaign.id)">{{ campaign.name }}</a>
            </div>
            <div class="col-xs-2" style="font-weight: bold;">
                Bankrate Select
            </div>
        </template>
        <template v-else>
            <div class="col-xs-4">
                <a :href="campaignUrl(campaign.id)">{{ campaign.name }}</a>
            </div>
        </template>

        <!-- STATUS -->
        <div class="col-xs-2">
            <br-switch
                v-if="canToggleCampaign()"
                :value="isCampaignActive"
                @input="toggleCampaignStatus()">
            </br-switch>
            <div v-else>{{ isCampaignActive ? 'Active' : 'Inactive' }}</div>
        </div>
        <!-- EVENTS -->
        <div class="col-xs-2" :class="{'text-muted': refreshingCampaignStats}">
            <span>
                {{ numberFormatter(campaign.click_count) }}
            </span>
        </div>
        <!-- TODAY'S SPEND -->
        <div class="col-xs-2" :class="{'text-muted': refreshingCampaignStats}">
            <span>
                {{ campaign.daily_spend | currencyOrDash }}
            </span>
        </div>
        <!-- AMOUNT SPENT -->
        <div class="col-xs-2" :class="{'text-muted': refreshingCampaignStats}">
            <span v-show="loading">
                <content-loader></content-loader>
            </span>
            <span v-show="!loading">
                {{ campaign.cost | currencyOrDash }}
            </span>
        </div>
    </div>
</template>

<script>
import campaignCommon from 'js/campaigns/common'
import ContentLoader from 'js/components/utils/content-loader'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
    name: 'campaign-dashboard-row',

    mixins: [campaignCommon],

    props: ['campaign', 'refreshingCampaignStats', 'loading'],

    data() {
        return {
            myCampaign: this.campaign,
            baseUrl: window.Portal.baseUrl,
            toggleProcessing: false,
        }
    },

    computed: {
        isCampaignActive() {
            return this.myCampaign.is_active;
        }
    },

    methods: {
        toggleCampaignStatus() {
            if (this.toggleProcessing) {
                console.warn('Toggle already in progress, ignoring duplicate request');
                return;
            }

            this.toggleProcessing = true;
            this.showLoading();

            let url = this.baseUrl + '/campaigns/' + this.myCampaign.id + '/';
            const action = this.myCampaign.is_active ? 'deactivate' : 'activate';
            const fullUrl = url + action;

            axios.put(fullUrl, {}, {
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ||
                                   window.Portal?.csrfToken ||
                                   window.Laravel?.csrfToken,
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                if (response.data.success) {
                    this.myCampaign.is_active = !this.myCampaign.is_active;
                }
                this.hideLoading();
                this.toggleProcessing = false;
            }).catch(error => {
                this.hideLoading();
                this.toggleProcessing = false;

                // Handle different types of errors
                if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
                    Swal.fire('Connection Error', 'Unable to connect to the server. Please check that the server is running and try again.', 'error');
                } else if (error.response && error.response.data) {
                    if (error.response.data.message) {
                        this.showErrorMessage(error.response.data.message);
                    } else if (error.response.data.errors) {
                        const errorMessage = Array.isArray(error.response.data.errors)
                            ? error.response.data.errors.join(', ')
                            : error.response.data.errors;
                        Swal.fire('Whoops!', errorMessage, 'error');
                    } else {
                        Swal.fire('Error', 'An unexpected error occurred. Please try again.', 'error');
                    }
                } else {
                    Swal.fire('Error', error.message || 'An unexpected error occurred. Please try again.', 'error');
                }
            });
        },
        campaignUrl(id) {
            return route('campaigns.show', id);
        },
        numberFormatter (num) {
            num = (num + '').replace(/[^0-9+\-Ee.]/g, '')
            return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
        canToggleCampaign() {
            if (this.campaign.is_advertiser_edit_blocked && !this.hasRole(['staff', 'engineer'])) {
                return false
            }

            return this.canEditWithSelect(this.campaign.blnBankrateSelect)
        }
    },

    components: {
        ContentLoader
    }
}
</script>
